export default {
  tokenWhiteList: [
    'Login',
    'Page404',
    'TestXysTest1',
    'TestXysTest2',
    'TestXysTest3',
    'ShowV2'
  ],
  loginPath:'/login',
  tokenKey:'token',
  // apiHost:'https://zutai-test.web.xinzhidi.cn/api',
  // apiHost:'https://zutai.web.xinzhidi.cn/api',
  // apiHost:'http://localhost:7201',
  apiHost:'https://zutai.api.anmei.xinzhidi.cn',
  appName:'安美云组态',
  appEnName:'XZD Configuration',
}